export const siteData = {
  name: "Strefa TOP",
  tagline: "Strefa TOP – więcej niż strzelanka.",
  phone: "+48 888 460 037",
  email: "kontakt@strefatop.pl",
  address: "ul. Nowa 5, Tarnów Opolski",
  location: "Las z bezpłatnym parkingiem",
  hours: "Cały czas – elastyczne, na życzenie klienta",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61590094123965",
    instagram: "#",
    tiktok: "#",
  },
  coordinates: {
    lat: 50.55925,
    lng: 18.112,
  },
} as const

export const navLinks = [
  { label: "O nas", href: "#about" },
  { label: "ASG & Paintball", href: "#disciplines" },
  { label: "Arsenał", href: "#arsenal" },
  { label: "Galeria", href: "/galeria" },
  { label: "Cennik", href: "#pricing" },
  { label: "Opinie", href: "#reviews" },
  { label: "Kontakt", href: "#contact" },
] as const

export const disciplines = [
  {
    id: "asg",
    title: "CO TO JEST ASG?",
    icon: "Crosshair",
    description: "ASG (Airsoft Gun) to sport i hobby, w którym używa się replik prawdziwej broni strzelającej plastikowymi kulkami 6mm. Zabawa łączy elementy taktyki wojskowej, pracy zespołowej i czystej adrenaliny.",
    features: [
      "Kulki plastikowe 6mm",
      "Repliki prawdziwej broni",
      "Maksymalny realizm",
      "Profesjonalne wyposażenie",
    ],
    color: "military",
  },
  {
    id: "paintball",
    title: "CO TO JEST PAINTBALL?",
    icon: "Target",
    description: "Paintball to klasyka grupowej rozrywki. Strzelasz kulkami z farbą – trafienie widoczne od razu. Idealne dla tych, którzy chcą się porządnie pobawić bez zbytniego skomplikowania zasad.",
    features: [
      "Kulki farbą na bazie wody",
      "Doskonały dla grup",
      "Widoczne trafienia",
      "Łatwy start dla każdego",
    ],
    color: "amber",
  },
] as const

export const arsenal = [
  {
    id: 1,
    name: "Broń airsoftowa CYMA AK CM035A",
    type: "Karabin szturmowy",
    description: "Klasyczna replika AK o solidnej konstrukcji i niezawodnym działaniu. Świetny wybór dla każdego gracza.",
    specs: { range: "~40-50m", ammo: "Kulki 6mm BB", fps: "~350-380" },
    image: "/images/replicas/karabin1.jpeg",
  },
  {
    id: 2,
    name: "Delta Armory broń airsoftowa AR15 SilentOps CQB Alpha EAGLE",
    type: "Karabin taktyczny",
    description: "Kompaktowa replika CQB z systemem SilentOps. Idealna na dynamiczne starcia w zwarciu.",
    specs: { range: "~30-40m", ammo: "Kulki 6mm BB", fps: "~320-350" },
    image: "/images/replicas/karabin2.jpeg",
  },
  {
    id: 3,
    name: "Karabin airsoftowy Delta Armory AR15 TEMPEST 1 Alpha Eagle",
    type: "Karabin szturmowy",
    description: "Pełnowymiarowa replika AR15 z serii TEMPEST. Precyzja i ergonomia w każdych warunkach.",
    specs: { range: "~35-45m", ammo: "Kulki 6mm BB", fps: "~330-360" },
    image: "/images/replicas/karabin3.jpeg",
  },
  {
    id: 4,
    name: "Broń airsoftowa Umarex H&K UMP",
    type: "Pistolet maszynowy",
    description: "Kompaktowy i zwrotny pistolet maszynowy H&K UMP. Doskonały na szybkie akcje i operacje CQB.",
    specs: { range: "~25-35m", ammo: "Kulki 6mm BB", fps: "~300-330" },
    image: "/images/replicas/karabin4.jpeg",
  },
] as const

export const events = [
  {
    icon: "Wine",
    title: "Wieczór kawalerski",
    description: "Żaden klub nie daje takiego kopa. Ostatnia noc wolności? Spędź ją z karabinem w dłoni.",
  },
  {
    icon: "Briefcase",
    title: "Impreza firmowa",
    description: "Integracja, która naprawdę integruje. Sprawdź, kto w Twoim teamie ma charakter dowódcy.",
  },
  {
    icon: "Cake",
    title: "Urodziny",
    description: "Prezent nie do pobicia. Przeżyj urodziny, które będą wspominane latami.",
  },
  {
    icon: "Trophy",
    title: "Turnieje ASG",
    description: "Mierzysz się z najlepszymi. Liczy się taktyka, refleks i zimna krew.",
  },
  {
    icon: "Users",
    title: "Rodzinne wyjścia",
    description: "Bezpieczna rozrywka dla całej rodziny. Dzieci i dorośli na jednym polu.",
  },
  {
    icon: "GraduationCap",
    title: "Eventy szkolne / klasowe",
    description: "Aktywna integracja poza klasą. Emocje i wspomnienia zamiast ławki.",
  },
] as const

export const pricingPackages = [
  {
    name: "Pakiet Standardowy",
    price: "120",
    unit: "zł / osoba",
    range: "2 – 10 osób",
    duration: "3h gry",
    popular: false,
    features: [
      "Maska ochronna",
      "Gogle ochronne",
      "Replika",
      "Pełen magazynek 300–500 kul",
      "Poligon przystosowany do gier ASG",
      "Szkolenie i opieka przeprowadzona przez koordynatora",
    ],
    ammo: { label: "Dokupienie kulek dla całej ekipy", price: "60 zł", detail: "4000 szt." },
  },
  {
    name: "Pakiet Grupowy",
    price: "110",
    unit: "zł / osoba",
    range: "11+ osób",
    duration: "3h gry",
    popular: true,
    features: [
      "Maska ochronna",
      "Gogle ochronne",
      "Replika",
      "Pełen magazynek 300–500 kul",
      "Poligon przystosowany do gier ASG",
      "Szkolenie i opieka przeprowadzona przez koordynatora",
    ],
    ammo: { label: "Dokupienie kulek dla całej ekipy", price: "55 zł", detail: "4000 szt." },
  },
] as const

export const pricingAddons = [
  {
    name: "Grill Gazowy",
    duration: "2h",
    price: "150",
    unit: "zł",
    features: [
      "Miejsce do odpoczynku",
      "Stół + krzesła",
      "Kubeczki wraz z talerzykami i sztućcami",
      "Grill mistrz",
    ],
    icon: "Flame",
  },
  {
    name: "Profesjonalny fotograf",
    price: "240",
    unit: "zł",
    features: [
      "Podczas gry będzie robił profesjonalne zdjęcia",
      "Pamiątka na dłużej",
    ],
    icon: "Camera",
  },
] as const

export const reviews = [
  {
    name: "Marek K.",
    location: "Opole",
    rating: 5,
    text: "Byliśmy tutaj z ekipą z pracy na integrację. Polecam w 100%. Organizacja na najwyższym poziomie, sprzęt rewelacyjny, instruktor z humorem i wiedzą. Na pewno wrócimy!",
  },
  {
    name: "Kamil W.",
    location: "Wrocław",
    rating: 5,
    text: "Wieczór kawalerski, którego nie zapomnimy do końca życia. Pan młody był szczęśliwy, drużyna zakochana w ASG. Czyste szaleństwo w pozytywnym sensie!",
  },
  {
    name: "Tomasz R.",
    location: "Tarnów Opolski",
    rating: 5,
    text: "Zabrałem syna na urodziny – wróciliśmy obaj jako fani ASG. Profesjonalne podejście, bezpieczeństwo na pierwszym miejscu. Wielkie brawa dla ekipy Strefy TOP!",
  },
  {
    name: "Anna M.",
    location: "Krapkowice",
    rating: 5,
    text: "Organizowaliśmy imprezę firmową dla 20 osób. Wszyscy byli zachwyceni! Atmosfera, sprzęt, teren – wszystko na najwyższym poziomie. Polecam każdej firmie.",
  },
  {
    name: "Piotr S.",
    location: "Opole",
    rating: 5,
    text: "Jako weteran ASG mogę powiedzieć – Strefa TOP to jedno z najlepszych miejsc w regionie. Profesjonalne repliki, świetny teren i ludzie, którzy kochają to, co robią.",
  },
] as const

export const galleryImages = [
  "/images/gallery/FB_IMG_1780393116837.jpg",
  "/images/gallery/FB_IMG_1780393120815.jpg",
  "/images/gallery/FB_IMG_1780393125573.jpg",
  "/images/gallery/FB_IMG_1780393142166.jpg",
  "/images/gallery/FB_IMG_1780393149480.jpg",
  "/images/gallery/FB_IMG_1780393157819.jpg",
] as const

export const features = [
  "Teren leśny — naturalne, klimatyczne pole gry",
  "Pełne wyposażenie w cenie — nie przynoś nic swojego",
  "Dopasowanie do grupy — od 2 do 50+ osób",
  "Elastyczne terminy — dostosowujemy się do Ciebie",
  "Bezpieczeństwo przede wszystkim — instruktaż przed każdym eventem",
  "Parking bezpłatny bezpośrednio przy terenie",
] as const
